import { lovemoScreenshots } from '@/mocks/lovemoContent';
import LovemoSectionHeading from '@/components/feature/LovemoSectionHeading';

export default function LovemoScreenshots() {
  return (
    <section id="lovemo-screenshots" className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-24">
        <LovemoSectionHeading
          eyebrow="软件截图"
          title="看看Lovemo的真实样子"
          desc="从聊天到语音、从心情记录到夜间模式，每个界面都为温柔陪伴而设计。"
        />

        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
          {lovemoScreenshots.map((shot, index) => (
            <figure
              key={shot.id}
              className={`lovemo-reveal group flex flex-col ${
                index === 4 ? 'col-span-2 sm:col-span-1' : ''
              }`}
              style={{ animationDelay: `${index * 70}ms` }}
            >
              <div className="rounded-[2rem] border border-background-300/60 bg-background-100 p-2.5 transition-transform duration-300 group-hover:-translate-y-1.5">
                <div className="relative overflow-hidden rounded-[1.6rem] bg-background-50">
                  <img
                    src={shot.image}
                    alt={`Lovemo${shot.title}界面截图`}
                    title={`Lovemo${shot.title}界面截图`}
                    className="aspect-[9/19] w-full object-cover object-top"
                    width={380}
                    height={760}
                  />
                </div>
              </div>
              <figcaption className="mt-3.5 px-1">
                <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                  {shot.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{shot.desc}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}